module.exports = __webpack_public_path__ + "static/img/toplogo.d51ea391.png";